export default "__VITE_ASSET__1bd0baf4__"